import React, { Fragment } from "react";
import { Box, Button, IconButton, TableCell, TableRow } from "@mui/material";

export default function TableItemComp({ item, sortData, action, activeRow }) {
  const filtered = Object.fromEntries(sortData?.filter((key) => item?.hasOwnProperty(key)).map((key) => [key, item[key]]) ?? []);

  const renderIncludeRows = () => {
    const rows = item?.includesRow;

    if (!rows) return null;

    // ReactElement
    if (React.isValidElement(rows)) {
      return rows;
    }

    // Array
    if (Array.isArray(rows)) {
      // Array of ReactElements
      if (rows.some((row) => React.isValidElement(row))) {
        return rows;
      }

      // Array of data objects
      return rows.map((val, index) => (
        <TableRow
          key={val?.id ?? index}
          sx={{
            background: "var(--light-grey)",
            "&:last-child td, &:last-child th": { border: 0 },
          }}
        >
          {Object.entries(val ?? {}).map(([key, value]) => (
            <TableCell
              key={key}
              sx={{
                textAlign: "center",
                verticalAlign: "top",
              }}
            >
              {value}
            </TableCell>
          ))}
        </TableRow>
      ));
    }

    // Any other ReactNode (string, number, fragment, etc.)
    return rows;
  };

  return (
    <Fragment>
      <TableRow
        key={item?.id}
        sx={{
          "&:last-child td, &:last-child th": { border: 0 },
          background: activeRow ? "var(--grey)" : "transparent",
        }}
      >
        {Object.entries(filtered ?? {}).map(([key, value]) => (
          <TableCell
            key={key}
            sx={{ textAlign: "center !important" }}
          >
            {value}
          </TableCell>
        ))}

        {Array.isArray(action) && (
          <TableCell
            sx={{
              textAlign: "center",
            }}
          >
            <Box
              display="flex"
              gap="6px"
              justifyContent="center"
              sx={{
                width: "200px",
                margin: "0 auto",
              }}
            >
              {action.map((v) => {
                const isDisabledByRequire = v?.require !== undefined && (Array.isArray(v.require) ? v.require.includes(item?.require) : v.require === item?.require);

                const isDisabledByRule = typeof v?.disabled === "function" ? v.disabled(item) : !!v?.disabled;

                const isDisabled = isDisabledByRequire || isDisabledByRule;

                const isDisplay = typeof v?.display === "function" ? v.display(item) : [undefined, true].includes(v?.display);

                const actionTitle = typeof v?.title === "function" ? v.title(item) : v?.title;

                if (!isDisplay) return null;

                return (
                  <Fragment key={v?.id}>
                    {v?.type === "icon" && (
                      <IconButton
                        disabled={isDisabled}
                        sx={{
                          background: "var(--grey) !important",
                          width: "34px",
                          height: "34px",
                          "& svg": {
                            color: isDisabled ? "#b0b0b0 !important" : "#000 !important",
                          },
                        }}
                        onClick={() => v?.onClick(item)}
                      >
                        {v?.icon}
                      </IconButton>
                    )}

                    {v?.type === "default" && (
                      <Button
                        size={v?.size ?? "medium"}
                        sx={{
                          whiteSpace: "nowrap",
                          fontSize: "12px",
                          width: v?.width,
                        }}
                        disabled={isDisabled}
                        variant={v?.variant ?? "contained"}
                        onClick={() => v?.onClick(item)}
                      >
                        {actionTitle}
                      </Button>
                    )}
                  </Fragment>
                );
              })}
            </Box>
          </TableCell>
        )}
      </TableRow>

      {/* INCLUDE ROW */}
      {renderIncludeRows()}
    </Fragment>
  );
}
